// 5 minutes
export const MAX_AUDIO_LENGTH = 2 * 60;
export const MARKETING_DOMAIN_URL = "https://talegacyremembered.com";
export const SERVICE_SESSION_ID = {
  IS_AUTOBIO: 4,
  IS_SELF_DEV: 3,
  IS_ANOTHER_STORY: 2,
};

export const TOOL_CHOICE_ID = {
  NEW: 1,
  REFORMULATE: 2,
  PLAN_FROM_NOTES: 3,
  CREATE_FROM_NOTES: 4,
};
